<template>
  <!-- eslint-disable max-len -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 150 150"
    aria-hidden="true"
    data-icon-name="apple_tv"
  >
    <g transform="translate(12 18)">
      <path d="M117.7,0H9.1C4.1,0,0,4.1,0,9.1v65.6c0,5,4.1,9.1,9.1,9.1h25.7l1.2-2.3H9.1c-3.8,0-6.8-3-6.8-6.8l0,0V9.1
        c0-3.8,3-6.8,6.8-6.8l0,0h108.6c3.8,0,6.8,3,6.8,6.8l0,0v65.6c0,3.8-3,6.8-6.8,6.8l0,0H90.1l1.4,2.3h26.2c5,0,9.1-4.1,9.1-9.1V9.1
        C126.7,4.1,122.7,0,117.7,0"/>
      <path d="M61.6,65.5c0.8-1,2.2-1.1,3.2-0.3c0,0,0,0,0,0c0.1,0.1,0.2,0.2,0.3,0.3l36,44c0.8,1,0.7,2.4-0.3,3.2
        c-0.4,0.3-0.9,0.5-1.4,0.5H27.4c-1.2,0-2.3-1-2.3-2.3c0-0.5,0.2-1,0.5-1.4L61.6,65.5z"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'AppleTvIcon',
};
</script>

<style lang="scss" scoped>
path {
  fill: var(--colors-main-font);
}
</style>
